import { PersonRatingContainer } from '../containers/PersonRatingContainer/index'

export const MeToPersonRatingPage = () => (
    <PersonRatingContainer type='ME_TO_PERSON'/>
)